const routes = {
  createStockTransfer: 'stock-transfer',
  getStockTransfers: 'stock-transfer',
  getStockTransferById: 'stock-transfer/',
  updateStockTransfer: 'stock-transfer/',
  deleteStockTransfer: 'stock-transfer/'
}

export default routes